import { css } from 'lit';

export const enrollmentTokenStyles = css`
  .token {
    display: block;
    margin: var(--space-2) 0;
    padding: var(--space-2) var(--space-3);
    border: var(--border-width) solid var(--border-strong);
    border-radius: var(--radius);
    background: var(--surface);
    overflow-wrap: anywhere;
    user-select: all;
  }

  pre {
    margin: var(--space-2) 0 0;
    padding: var(--space-2) var(--space-3);
    border-radius: var(--radius);
    background: var(--surface);
    overflow-x: auto;
    font-size: var(--font-size-md);
  }
`;
